import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-form" }
const _hoisted_5 = { class: "wrapper-image" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "wrapper-news-image" }
const _hoisted_8 = { class: "grid-image" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 2,
  class: "no-image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_GeneralInput = _resolveComponent("GeneralInput")!
  const _component_GeneralTextArea = _resolveComponent("GeneralTextArea")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "title" }, "Información de noticia", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_GeneralInput, {
          text: _ctx.title.val,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title.val) = $event)),
          value: _ctx.title.val,
          label: 'Título',
          "has-error": _ctx.title.enabled,
          error: _ctx.title.errors.length === 0 ? '' : _ctx.title.errors[0],
          class: "title"
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_GeneralTextArea, {
          text: _ctx.description.val,
          "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description.val) = $event)),
          value: _ctx.description.val,
          label: 'Noticia',
          "has-error": _ctx.description.enabled,
          error: _ctx.description.errors.length === 0 ? '' : _ctx.description.errors[0],
          class: "news"
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("p", null, "Imagen", -1)),
            _createVNode(_component_SecondaryButton, {
              buttonLabel: 'Subir imagen',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.fileImage.click()))
            }),
            _createElementVNode("input", {
              type: "file",
              ref: "fileImage",
              hidden: "",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args))),
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($event.target.value = ''))
            }, null, 544)
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "La imagen debe tener una relación 920/480.", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("figure", _hoisted_8, [
            (_ctx.showPreview)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.previewImage,
                  class: "news-image"
                }, null, 8, _hoisted_9))
              : (_ctx.showImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.news.slider,
                    class: "news-image"
                  }, null, 8, _hoisted_10))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, "Sin imagen"))
          ]),
          (_ctx.showPreview)
            ? (_openBlock(), _createBlock(_component_DeleteButton, {
                key: 0,
                class: "delete",
                onClick: _ctx.removeUploadFile
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Guardar',
        class: "margin-button",
        "is-disabled": _ctx.disabledForm,
        onClick: _ctx.createEditNews
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}